import React from "react";
import backgroundImg from "../images/patrimoine.png";
import icon1 from "../images/icons/7.png";
import icon2 from "../images/icons/8.png";

import { Card, CardContent, CardTitle } from "../components/ui/card";
import { Link } from "react-router-dom";

const Presse = () => {
  return (
    <div>
      <section
        className="p-10 text-center lg:p-32 bg-black/70 bg-blend-overlay "
        style={{
          backgroundImage: `url(${backgroundImg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <h1 className="text-2xl font-bold text-center text-white md:text-4xl lg:text-7xl">
          {"Presse"}
        </h1>

        {/* <div className="flex justify-center mt-3">
        <p className="w-full text-white ">{"desc"}</p>
      </div> */}
      </section>
      <div className="flex justify-center mt-20 mb-20 space-x-10">
        <div className="group">
          <Link to="/presse/communiquées">
            <Card className="transition duration-300 ease-in-out cursor-pointer group-hover:shadow-xl">
              <CardContent className="flex items-center justify-center mt-2">
                <img
                  src={icon1}
                  alt=""
                  className="transition-transform duration-300 ease-in-out group-hover:scale-110"
                />
              </CardContent>
              <CardTitle className="p-4 transition-colors duration-300 ease-in-out group-hover:text-primary">
                Communiqués de presse
              </CardTitle>
            </Card>
          </Link>
        </div>
        <div className=" group">
          <Link to={"/presse/retombées"}>
            <Card className="transition duration-300 ease-in-out cursor-pointer group-hover:shadow-xl">
              <CardContent className="flex items-center justify-center mt-2">
                <img
                  src={icon2}
                  alt=""
                  className="transition-transform duration-300 ease-in-out group-hover:scale-110"
                />
              </CardContent>
              <CardTitle className="p-4 transition-colors duration-300 ease-in-out group-hover:text-primary">
                Retombées de presse
              </CardTitle>
            </Card>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Presse;
